// src/components/Footer.jsx
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const goToHomeSection = (sectionId) => {
    const scrollToSection = () => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    if (location.pathname === "/") {
      scrollToSection();
      return;
    }

    navigate("/");
    window.setTimeout(scrollToSection, 300);
  };

  return (
    <footer className="bg-[#0f172a] text-white mt-12">
      <div className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-8">
        <div>
          <img src="/images/logo.png" alt="Logo" className="h-12 mb-4" />
          <p className="text-gray-300 text-sm">
            Portal de Ordenamientos Territoriales del Estado de Jalisco.
          </p>
        </div>
        <div>
          <h3 className="font-semibold mb-3">Enlaces</h3>
          <ul className="space-y-2 text-gray-300">
            <li>
              <button
                type="button"
                onClick={() => goToHomeSection("regiones")}
                className="text-left hover:text-white transition"
              >
                Inicio
              </button>
            </li>
            <li>
              <button
                type="button"
                onClick={() => goToHomeSection("regiones")}
                className="text-left hover:text-white transition"
              >
                Regiones
              </button>
            </li>
            <li><Link to="https://sigat.semadet.jalisco.gob.mx/ordenamiento/POET.html" target="_blank" rel="noopener noreferrer">Ordenamiento Estatal Vigente</Link></li>
            {/* <li><Link to="/contacto">Contacto</Link></li> */}
          </ul>
        </div>
        <div>
          <h3 className="font-semibold mb-3">Contacto</h3>
          <p className="text-gray-300 text-sm">Tel: (33) 3030 8250</p>
          <p className="text-gray-300 text-sm">Email: ordenamientoecologico.semadet@jalisco.gob.mx</p>
        </div>
      </div>
      <div className="bg-[#0c1322] py-4 text-center text-gray-400 text-sm">
        © 2025 Gobierno de Jalisco · Sistemas SEMADET · Todos los derechos reservados
      </div>
    </footer>
  );
}
